/**
 * Хук для проверки RBAC permissions: can (одно), canAny (любое из), canAll (все)
 * Superadmin (без tenant_id) имеет все права автоматически
 */
import { useMemo } from 'react';
import { useAuth } from './useAuth';

export function usePermissions() {
  const { user, permissions: permissionsArray } = useAuth();
  
  const permissions = useMemo(() => {
    return new Set(permissionsArray || []);
  }, [permissionsArray]);
  
  /**
   * Проверяет наличие permission
   * @param permission - строка вида "resource:action" или просто "resource"
   */
  const can = (permission: string): boolean => {
    if (!user) return false;
    
    // Superadmin может всё
    if (!user.tenant_id) return true;
    
    // Точное совпадение
    if (permissions.has(permission)) return true;
    
    // Проверка wildcard: если запрашивают "messages", проверяем "messages:*"
    if (!permission.includes(':')) {
      return Array.from(permissions).some(p => p.startsWith(`${permission}:`));
    }
    
    return false;
  };
  
  /**
   * Проверяет наличие любого из permissions
   */
  const canAny = (...perms: string[]): boolean => {
    return perms.some(can);
  };
  
  /**
   * Проверяет наличие всех permissions
   */
  const canAll = (...perms: string[]): boolean => {
    return perms.every(can);
  };
  
  return { can, canAny, canAll, permissions: Array.from(permissions) };
}

